import { useMemo } from "react";
import type { Utility } from "@cs2/contracts";
import { thrownUtilityGeometry } from "./scene.js";

/** Memoisierter Zugriff auf `thrownUtilityGeometry` — je Utility neu berechnet. */
export function useThrownUtilityGeometry(
  utility: Utility,
): ReturnType<typeof thrownUtilityGeometry> {
  return useMemo(() => thrownUtilityGeometry(utility), [utility]);
}
